import { getEvents } from '@app/analytics/models/helpers';
import { TagContainer } from '@app/analytics/models/container';
import { MmaoCtaClick } from '@app/store';

/**
 * When the MMAO popin form displays (form starts).
 */
const events = getEvents((action: MmaoCtaClick) => [
  {
    type: 'event',
    container: TagContainer.Analytics,
    payload: {
      event: 'mmaoClick',
      user_category: action.payload.userRole.toLowerCase(),
      product_brand: action.payload.product.brand.name,
      product_univers: action.payload.product.universe.name,
      product_category: action.payload.product.category.name
    }
  }
]);

export default events;
